import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";

import { callGet, callPost } from "../../http_client";
import { setApiToken } from "../auth/side_effects";

import { gatesFetchError, gatesFetchSuccess, loginAsUser } from "./actions";
import { GatesActionTypes } from "./types";

export function* handleGatesFetch(): SagaIterator {
  try {
    const res = yield call(callGet, "/gates/");
    yield put(gatesFetchSuccess({ items: res.data }));
  } catch (err) {
    yield put(gatesFetchError(err.message));
  }
}

export function* handleLoginAsUser(action: ReturnType<typeof loginAsUser>): SagaIterator {
  try {
    const resp = yield call(callPost, "/auth/as_user/", { gateId: action.payload });
    yield call(setApiToken, resp.data.token);
    window.location.replace("/");
  } catch (err) {
    const message = `[${err.response.status}] ${err.response.statusText}. ${err.response.data.detail}`;
    yield put(gatesFetchError(message));
  }
}

function* watchGatesSagas(): SagaIterator {
  yield takeLatest(GatesActionTypes.FETCH_REQUEST, handleGatesFetch);
  yield takeLatest(GatesActionTypes.LOGIN_AS_USER, handleLoginAsUser);
}

export default watchGatesSagas;
